import { v4 as uuidv4 } from 'uuid';
import { createContext, useContext, useEffect, useState } from "react";
import { queueNum } from "../components/indexDB/indexDBStora";
import { switchh } from "./switch";
// import { useNavigate } from "react-router-dom";


export const context = createContext();
export default function Context({children}) {
    const { loadingProcess } = useContext(switchh);
    const ResetSerial = {
        prefix:"",
        code: "",
        weight:"",
        // check digital
        CD:""
    }
    
    const invoiceId = uuidv4();
    const [serial,setSerial] = useState(ResetSerial);
    const [addOne, setAddOne] = useState(false)
    const [cart,setCart] = useState([]);
    const resetDeleteBox = {status: false, id: 0};
    const [deleteBox, setDeleteBox] = useState(resetDeleteBox);
    const [edit,setEdit] = useState({});
    const [discount, setDiscount] = useState("");
    const [search, setSearch] = useState({
        bySearial: false,
        value: ""
    });
    const [catChoose,setCatChoose] = useState("");
    const [total,setTotal] = useState(0);
    const [discount2,setDiscount2] = useState(0);
    const [product,setProduct] = useState();
    const [queueId, setQueueId] = useState(0);
    const [invoiceNum, setInvoiceNum] = useState(0);
    const [clientFlag, setClientFlag] = useState("delivery");
    const [pointer, setPointer] = useState({});

    useEffect(() => {
    const getNumInvoice = async () => {
        const queue_number = await queueNum();
        setInvoiceNum(queue_number);
    };
    getNumInvoice();
}, [loadingProcess]);

    const parent = {
        setCart, cart,
        setSerial, serial,
        edit, setEdit,
        queueId, setQueueId,
        invoiceNum, setInvoiceNum,
        discount, setDiscount,
        deleteBox, setDeleteBox,
        product,setProduct,
        search, setSearch,
        addOne, setAddOne,
        ResetSerial,
        clientFlag, setClientFlag,
        invoiceId,
        total, setTotal,
        discount2, setDiscount2,
        catChoose, setCatChoose,
        pointer, setPointer,
        resetDeleteBox
    }

    return <context.Provider value={parent}>{children}</context.Provider>
}